module.exports = __webpack_public_path__ + "static/img/4848_phase_function_Paper_Points.a8b576f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4848_phase_function_Paper_Points.png
// module id = YGPN
// module chunks = 0